"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFormatterToken = void 0;
/**
 * The supported format string tokens that can be used with the [[I18N.date]] method.
 * Adheres to the format tokens provided by [date-fns](https://date-fns.org/v1.28.0/docs/format).
 */
var DateFormatterToken;
(function (DateFormatterToken) {
    DateFormatterToken["MonthNumeric"] = "M";
    DateFormatterToken["MonthOrdinal"] = "Mo";
    DateFormatterToken["MonthTwoDigit"] = "MM";
    DateFormatterToken["MonthShort"] = "MMM";
    DateFormatterToken["MonthLong"] = "MMMM";
    DateFormatterToken["QuarterNumeric"] = "Q";
    DateFormatterToken["QuarterOrdinal"] = "Qo";
    DateFormatterToken["DayOfMonthNumeric"] = "D";
    DateFormatterToken["DayOfMonthOrdinal"] = "Do";
    DateFormatterToken["DayOfMonthTwoDigit"] = "DD";
    DateFormatterToken["DayOfYearNumeric"] = "DDD";
    DateFormatterToken["DayOfYearOrdinal"] = "DDDo";
    DateFormatterToken["DayOfYearThreeDigit"] = "DDDD";
    DateFormatterToken["DayOfWeekZeroIndexed"] = "d";
    DateFormatterToken["DayOfWeekOrdinal"] = "do";
    DateFormatterToken["DayOfWeekTwoChar"] = "dd";
    DateFormatterToken["DayOfWeekShort"] = "ddd";
    DateFormatterToken["DayOfWeekLong"] = "dddd";
    DateFormatterToken["DayOfWeekNumeric"] = "E";
    DateFormatterToken["WeekOfYearNumeric"] = "W";
    DateFormatterToken["WeekOfYearOrdinal"] = "Wo";
    DateFormatterToken["WeekOfYearTwoDigit"] = "WW";
    DateFormatterToken["YearTwoDigit"] = "YY";
    DateFormatterToken["YearNumeric"] = "YYYY";
    DateFormatterToken["YearWeekNumberingTwoDigit"] = "GG";
    DateFormatterToken["YearWeekNumberingNumeric"] = "GGGG";
    DateFormatterToken["Hour24Numeric"] = "H";
    DateFormatterToken["Hour24TwoDigit"] = "HH";
    DateFormatterToken["Hour12Numeric"] = "h";
    DateFormatterToken["Hour12TwoDigit"] = "hh";
    DateFormatterToken["MinuteNumeric"] = "m";
    DateFormatterToken["MinuteTwoDigit"] = "mm";
    DateFormatterToken["SecondNumeric"] = "s";
    DateFormatterToken["SecondTwoDigit"] = "ss";
    DateFormatterToken["SecondTenth"] = "S";
    DateFormatterToken["SecondHundredth"] = "SS";
    DateFormatterToken["Millisecond"] = "SSS";
    DateFormatterToken["MeridiemUpperCase"] = "A";
    DateFormatterToken["MeridiemLowerCase"] = "a";
    DateFormatterToken["MeridiemFull"] = "aa";
    DateFormatterToken["Offset"] = "Z";
    DateFormatterToken["OffsetWithoutSeparator"] = "ZZ";
    DateFormatterToken["TimestampSeconds"] = "X";
    DateFormatterToken["TimestampMilliseconds"] = "x";
})(DateFormatterToken = exports.DateFormatterToken || (exports.DateFormatterToken = {}));
//# sourceMappingURL=date-formatter-token.js.map